import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-final-form';
import { Button, Modal } from 'react-bootstrap';
import { DatePickerField } from '../fields';
import { isCourtDrive } from '../../../util/globalUtils';

import '../AdvancedSearch.less';

const DateFilterModal = ({ onSave, show, onClose, filter }) => {
  const { tab, court_type } = filter;
  const visible = {
    date_closed: !['schedules', 'petitions'].includes(tab),
    date_dismissed: !['schedules', 'petitions'].includes(tab) && !['civil', 'criminal'].includes(court_type),
    date_discharged: !['schedules', 'petitions'].includes(tab) && !['civil', 'criminal'].includes(court_type),
    date_doc_filed: !['cases', 'petitions'].includes(tab),
    open_cases: !isCourtDrive() && ['petitions', 'schedules'].includes(tab) && court_type === 'bankruptcy',
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} dialogClassName="advanced-search-modal">
      <div className="filings-page">
        <Form
          onSubmit={onSave}
          initialValues={filter}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Modal.Header closeButton>
                <Modal.Title>Date Filters</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="advanced-search-form">
                  <div className="form-item">
                    <label>Cases filed</label>
                    <div className="form-item-row">
                      <DatePickerField fieldName="date_filed_from" placeholderText="From" />
                      <DatePickerField fieldName="date_filed_to" placeholderText="Through" />
                    </div>
                  </div>
                  {visible.open_cases && (
                    <div className="form-item">
                      <label>Open cases</label>
                      <div className="form-item-row">
                        <DatePickerField fieldName="open_cases_from" placeholderText="From" />
                        <DatePickerField fieldName="open_cases_to" placeholderText="Through" />
                      </div>
                    </div>
                  )}
                  {visible.date_closed && (
                    <div className="form-item">
                      <label>Cases closed</label>
                      <div className="form-item-row">
                        <DatePickerField fieldName="date_closed_from" placeholderText="From" />
                        <DatePickerField fieldName="date_closed_to" placeholderText="Through" />
                      </div>
                    </div>
                  )}
                  {visible.date_dismissed && (
                    <div className="form-item">
                      <label>Cases dismissed</label>
                      <div className="form-item-row">
                        <DatePickerField fieldName="date_dismissed_from" placeholderText="From" />
                        <DatePickerField fieldName="date_dismissed_to" placeholderText="Through" />
                      </div>
                    </div>
                  )}
                  {visible.date_discharged && (
                    <div className="form-item">
                      <label>Cases discharged</label>
                      <div className="form-item-row">
                        <DatePickerField fieldName="date_discharged_from" placeholderText="From" />
                        <DatePickerField fieldName="date_discharged_to" placeholderText="Through" />
                      </div>
                    </div>
                  )}
                  {visible.date_doc_filed && (
                    <div className="form-item">
                      <label>Documents filed</label>
                      <div className="form-item-row">
                        <DatePickerField fieldName="date_doc_filed_from" placeholderText="From" />
                        <DatePickerField fieldName="date_doc_filed_to" placeholderText="Through" />
                      </div>
                    </div>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={onClose}>Cancel</Button>
                <Button bsStyle="primary" type="submit">
                  Apply
                </Button>
              </Modal.Footer>
            </form>
          )}
        />
      </div>
    </Modal>
  );
};

DateFilterModal.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  show: PropTypes.bool,
  filter: PropTypes.object.isRequired,
};

DateFilterModal.defaultProps = {
  show: false,
};

export default DateFilterModal;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/resultForms/DateFilterModal.jsx